import React from "react";
import "../styles.css";

const lessonTypes = [
  { icon: "🥁", title: "Drums" },
  { icon: "🎸", title: "Electric Guitar" },
  { icon: "🎸", title: "Bass Guitar" },
  { icon: "🎶", title: "Acoustic Guitar" },
  { icon: "🎤", title: "Vocals" },
  { icon: "🎚️", title: "Sound Engineering" },
];

const Lessons = () => {
  return (
    <div className="page-container lessons-page">
      <section className="lessons-hero">
        <p className="eyebrow">Learn · Play · Create</p>
        <h1>Music Lessons</h1>
        <p className="lessons-intro">
          Practical, one-on-one music tuition for beginners through to experienced
          musicians, right here at X Fire Music.
        </p>
      </section>

      <section className="lesson-grid" aria-label="Available lessons">
        {lessonTypes.map((lesson) => (
          <div className="lesson-card" key={lesson.title}>
            <span className="lesson-icon" aria-hidden="true">{lesson.icon}</span>
            <h2>{lesson.title}</h2>
          </div>
        ))}
      </section>

      <section className="lesson-info-card">
        <div className="lesson-price-block">
          <span className="lesson-price">$40</span>
          <span className="lesson-price-detail">per half-hour session</span>
        </div>
        <div className="lesson-info-copy">
          <h2>Bookings essential</h2>
          <p>Group sessions are also available. Ask us about options that suit you.</p>
        </div>
      </section>

      <section className="lesson-cta">
        <h2>Ready to get started?</h2>
        <p>Get in touch and we’ll help you organise the right lesson.</p>
        <div className="store-actions">
          <a className="store-btn store-btn-primary" href="tel:+61457170347">📞 Call X Fire Music</a>
          <a className="store-btn" href="mailto:info@xfiremusic.com.au">✉️ Email us</a>
        </div>
      </section>
    </div>
  );
};

export default Lessons;
